export const companies = (state) => { return state.companies };
